module.exports = __webpack_public_path__ + "19734624d0e18b1d6d3dfa80373f349c.svg";